module.exports = __webpack_public_path__ + "img/architecture-style-icon_3.f46b0230.png";